import { Link } from "wouter";
import { ThemeToggle } from "@/components/v2/theme-toggle";
import DataHygiene from "./data-hygiene";

const later = ["Team and access", "Audit and exports", "TFN redaction operations", "Integrations", "Retention"];

function UnavailableSection({ name }: { name: string }) {
  return <div className="crmx-settings-row is-unavailable" aria-disabled="true">
    <span>{name}</span><span className="crmx-settings-kicker">Not yet available</span>
  </div>;
}

export default function SettingsShell() {
  return <div className="crmx-v2 crmx-settings-shell">
    <aside className="crmx-settings-sections" aria-label="Settings sections">
      <header><span className="crmx-settings-kicker">Administrator only</span><h2>Settings</h2></header>
      <div className="crmx-settings-section-group">
        <h3 className="crmx-settings-kicker">Administration</h3>
        <Link href="/settings/data-hygiene" className="crmx-settings-row is-selected" aria-current="page">Data hygiene</Link>
        {later.map(name => <UnavailableSection key={name} name={name} />)}
      </div>
      <div className="crmx-settings-section-group">
        <h3 className="crmx-settings-kicker">Organisation policy</h3>
        <UnavailableSection name="Engine and org settings" />
      </div>
    </aside>
    <main className="crmx-settings-main" data-testid="settings-data-hygiene">
      <header className="crmx-v2-header">
        <div><span className="crmx-settings-kicker">Settings · Administration</span>
          <h1>Data hygiene</h1><p>Three read-only checks. Nothing on this page changes, removes or exports data.</p>
        </div>
        <ThemeToggle />
      </header>
      <DataHygiene />
    </main>
  </div>;
}
